import { useSelector, useDispatch } from 'react-redux';
import { fetchUser, updateOnboarding, setUser } from '../store/slices/userSlice';

export const useUserRedux = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  
  const refreshUser = () => {
    dispatch(fetchUser());
  };
  
  const completeOnboarding = () => {
    dispatch(updateOnboarding());
  };
  
  const setUserRedux = (userData) => {
    dispatch(setUser(userData));
  };
  
  return {
    ...user,
    refreshUser,
    completeOnboarding,
    setUser: setUserRedux,
  };
};
